import { useEffect, useState } from 'react'

/**
 * Detect whether we should use the mobile layout.
 *
 * We used to rely purely on viewport width, which caused desktop
 * split-screen windows (like Dia or narrow browser panes) to flip
 * into the mobile experience and lose window state. Instead, we now
 * treat "mobile" as "coarse pointer / touch-centric device".
 *
 * The optional breakpoint is kept for backwards compatibility but is
 * no longer the primary signal on desktop.
 */
const useIsMobile = (_breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkDevice = () => {
      if (typeof window === 'undefined') {
        setIsMobile(false)
        return
      }

      const hasCoarsePointer =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(pointer: coarse)').matches

      const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
      const uaLooksMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua)

      setIsMobile(hasCoarsePointer || uaLooksMobile)
    }

    // Initial check
    checkDevice()

    // Re-check on resize/orientation changes in case environment changes
    window.addEventListener('resize', checkDevice)
    window.addEventListener('orientationchange', checkDevice as any)

    return () => {
      window.removeEventListener('resize', checkDevice)
      window.removeEventListener('orientationchange', checkDevice as any)
    }
  }, [])

  return isMobile
}

export default useIsMobile
